require('slick-carousel');

import './../../stylesheets/carousel';

import slickPrevImage from 'design/images/arrows/slider_arrow_left.png';
import slickNextImage from 'design/images/arrows/slider_arrow_right.png';


// 画像ナビゲーション付きの同期カルーセル
export function syncingCarousel () {
  const nav = document.getElementById('main-slick-nav');

  $('#main-slick').slick({
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: $('#main-slick-nav'),
    prevArrow: '<img src="' + slickPrevImage + '" class="slider-arrow slick-prev" />',
    nextArrow: '<img src="' + slickNextImage + '" class="slider-arrow slick-next" />',
  });

  if (!!nav) {
    $('#main-slick-nav').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      focusOnSelect: true,
      asNavFor: $('#main-slick')
    });
  }
}

// メインカルーセルとトピックスのフォームでURLに必須ラベルを追加
export function addDispositionRequired () {
  const dispositions = document.querySelectorAll('input[name$="[disposition]"]');
  for (var disposition in dispositions) {
    const object = dispositions[disposition];
    if (object.checked) {
      changeFormDispositionRadioButton(object);
    }
  }
}

// メインカルーセルとトピックスのフォームでURLに必須ラベルを追加
export function selectDisposition () {
  $('input[name$="[disposition]"]').change(function () {
    changeFormDispositionRadioButton(this);
  })
}

// メインカルーセルとトピックスのフォームで配置の選択によって必須を動的に変える
function changeFormDispositionRadioButton (element) {
  // URL
  const urlElement = document.querySelector('input[name$="[url]"]');
  // 資料ラベル
  const documentLabel = document.querySelector('.material-document-lagel');

  if (element.value == 'url') {
    // URL入力可
    urlElement.disabled = false;
    // URLに必須を追加
    urlElement.parentElement.querySelector('label').classList.add('required');
    // 資料から必須を削除
    documentLabel.classList.remove('required');
  } else if (element.value == 'attachment') {
    // URL入力不可
    urlElement.disabled = true;
    // URLから必須を削除
    urlElement.parentElement.querySelector('label').classList.remove('required');
    // 資料に必須を追加
    documentLabel.classList.add('required');
  }
}

// メインカルーセルとトピックスの一覧で公開と非公開を切り替える
export function switchPublishButton () {
  $('.switch_uses').click(function () {
    switchPublishStatus(this);
  })
}

function switchPublishStatus (element) {
  // tokenを取得
  var token = document.getElementsByName('csrf-token').item(0).content;
  let xmlHttpRequest = new XMLHttpRequest();
  xmlHttpRequest.open('PUT', element.dataset.url)
  xmlHttpRequest.setRequestHeader('X-CSRF-Token',token);
  xmlHttpRequest.send();

  xmlHttpRequest.onreadystatechange = function() {
    if (xmlHttpRequest.readyState === 4) {
      if (xmlHttpRequest.status === 200) {
        if (element.classList.contains('btn-warning')) {
          // ボタンのテキストを公開中に更新
          element.innerText = '公開中';
          // ボタンのクラスを変更
          element.classList.remove('btn-warning');
          element.classList.add('btn-info');
        } else {
          // ボタンのテキストを非公開に更新
          element.innerText = '非公開';
          // ボタンのクラスを変更
          element.classList.remove('btn-info');
          element.classList.add('btn-warning');
        }
      } else {
        alert('操作する権限がありません。');
      }
    }
  };
}